import {FC, ReactNode} from 'react';
import clsx from 'clsx';
import LinkButton from 'components/LinkButton';
import {Size} from 'types';
import {actionLink} from '../styles.module.css';

export const SIZES: Record<Size, string> = {
    base: 'text-base py-2 px-3',
    lg: 'text-lg py-2 px-4',
    sm: 'text-sm py-1.5 px-2',
    xl: 'text-xl py-2.5 px-4',
    xs: 'text-xs py-1 px-1.5',
};

type DropdownItemProps = {
    children: ReactNode;
    className?: string;
    disabled?: boolean;
    href: string;
    size?: Size;
};

const DropdownActionLink: FC<DropdownItemProps> = ({
    children,
    className,
    disabled,
    href,
    size = 'base',
}) => (
    <LinkButton
        className={clsx(
            SIZES[size],
            actionLink,
            'pointer-events-auto pr-8 justify-start text-sm w-full',
            className,
        )}
        disabled={disabled}
        href={href}
        kind="secondary"
    >
        {children}
    </LinkButton>
);

export default DropdownActionLink;
